import React from "react"
import { Classes, FormGroup, FormGroupProps } from "@blueprintjs/core"
import classNames from "utils/classNames"

export interface CustomFormGroupProps extends FormGroupProps {
  big?: boolean
  required?: boolean
  error?: string
  id?: string
  fill?: boolean
}
const CustomFormGroup = ({
  children,
  className,
  big,
  label,
  helperText,
  intent,
  labelInfo,
  required,
  error,
  id,
  ...otherProps
}: CustomFormGroupProps) => {
  return (
    <FormGroup
      className={classNames(
        "vt-form-group",
        { "vt-form-group-big": big },
        className
      )}
      helperText={error ? error : helperText}
      intent={error ? "danger" : "none"}
      labelInfo={
        required ? <span className={Classes.INTENT_DANGER}>*</span> : labelInfo
      }
      label={label}
      {...otherProps}
    >
      {children}
    </FormGroup>
  )
}

export default CustomFormGroup
